import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { ModalAlert } from "../su/Modals.js";

export default class PageDefault extends PageCommon {
	constructor() {
		super();
	}
	init($data) {
		super.init($data);

		if ($data)
			this.Locale = $data.Locale;

		this.showPreloader(false);
		Pqp.trace("PageDefault - Hello world");
		// dispaccio un evento globale
		let searchButton = $('.js-search-btn');
		let searchbar = $('.js-search-input');
		if (searchbar.val().length < 3) {
			searchButton.css('pointer-events', 'none');
			searchButton.addClass('disabled');
		}
		searchbar.on('input', () => {
			if (searchbar.val().length < 3) {
				searchButton.css('pointer-events', 'none');
				searchButton.addClass('disabled');
				return;
			}
			searchButton.css('pointer-events', 'all');
			searchButton.removeClass('disabled')
		});

		this.setHeaderLinks();

		searchButton.on('click', () => {
			this.showPreloader(true);
			const rq = {
				Query: searchbar.val()
			}


			const response = thatServiceManeger.standardCall('/api/app/search', rq, (rs) => {
				this.showPreloader(true);
				if (rs?.StatusCode >= 400) {
					let modal = new ModalAlert($("#template-modalAlert"));
					modal.create(
						{
							title: TheApp.Res[TheApp.Locale]["ERROR.PRODUCT_SEARCH.TITLE"],
							body: TheApp.Res[TheApp.Locale]["ERROR.PRODUCT_SEARCH.TEXT"],
							close: "CLOSE",
							error: true
						});
					modal.init();
					this.showPreloader(false);
					return;
				}

				let productListContainer = $('.product-list');
				productListContainer.html('');
				const prodotti = rs.ListaProdotti;

				if (prodotti.length == 0) {
					let cloneNoItemsFound = $('#template-placeholder-no-items-found').clone();
					productListContainer.append(cloneNoItemsFound);
					this.showPreloader(false);
					return;
				}
				for (let prodotto of prodotti) {
					let cloneCardTemplate = $('#template-product-card').clone();
					cloneCardTemplate.attr('id', prodotto.Uid);
					//cloneCardTemplate.removeClass('product-card-template');

					let productName = cloneCardTemplate.find('.product-name').text(prodotto?.Nome);
					let productCode = cloneCardTemplate.find('.product-code').text(prodotto?.Uid);

					let productImage = cloneCardTemplate.find('.product-image');
					productImage.attr('src', prodotto?.Immagine);
					productListContainer.append(cloneCardTemplate);

					let overlay = $('.overlay-tabella-smaltimento');
					let btnOpenOverlay = cloneCardTemplate.find('.js-btn-detail');

					btnOpenOverlay.on('click', () => {
						this.showPreloader(true);
						let request = {
							Uid: productCode.text(),
							Locale: this.Locale
						}
						thatServiceManeger.standardCall('/api/app/getwaste', request, (rs) => {
							let productDescription = $('.product-description');
							productDescription.text(rs?.waste?.Description);

							let rowPart = overlay.find('.row-part');
							$(rowPart).html('');

							let rowCode = overlay.find('.row-code');
							$(rowCode).html('');
							let rowMaterial = overlay.find('.row-material');
							$(rowMaterial).html('');
							let rowWasteType = overlay.find('.row-waste-type');
							$(rowWasteType).html('');
							

							for (let item of rs?.waste?.Items) {
								let tdPart = $('<td></td>').text(item.Part.Label.toUpperCase());
								tdPart.css('Background', item?.CodiceNormativo?.Colore);
								tdPart.css('Color', item?.CodiceNormativo?.ColoreTesto);
								rowPart.append(tdPart);

								let tdCode = $('<td></td>').text(item.CodiceNormativo.Label.toUpperCase());
								rowCode.append(tdCode);

								let tdMaterial = $('<td></td>').text(item.CodiceNormativo.Materiale.Label.toUpperCase());
								rowMaterial.append(tdMaterial);
							}

							let colSpan = 1;
							for (let index in rs?.waste?.Items) {
								let currentElement = rs?.waste?.Items[+index];
								let nextElement = rs?.waste?.Items[+index + 1];

								if (currentElement?.CodiceNormativo?.WasteType?.toUpperCase() != nextElement?.CodiceNormativo?.WasteType?.toUpperCase() || index == rs?.waste?.Items?.length) {
									let tdWasteType = $('<td></td>').text(currentElement?.CodiceNormativo?.WasteType?.toUpperCase()).attr('colspan', colSpan);
									rowWasteType.append(tdWasteType);
									colSpan = 0;
								}

								colSpan++;
							}

							let rowConsigli = $('.row-consigli');
							let consigli = "";
							try {
								consigli = rs?.waste?.Consigli;
							} catch (ex) {

							}
							//debugger;

							if (!Pqp.isNullOrEmpty(consigli)) {
								rowConsigli.html('');
								let tdConsigli = $('<td class="js-td-consigli"></td>').text(consigli);
								tdConsigli.attr('colspan', colSpan);
								rowConsigli.append(tdConsigli);
							}
							
							rowConsigli.find('.js-td-consigli').attr('colspan', rs?.waste?.Items?.length);

							this.showPreloader(false);
						});

						$("html").css("overflow", "hidden");
						overlay.show();
						let btnClose = overlay.find('.btn-close-overlay');
						btnClose.off('click');
						btnClose.on('click', () => {
							overlay.hide();
							$("html").css("overflow", "auto");
						});

						let image = overlay.find('.img-smaltimento');
						image.attr('src', productImage.attr('src'));

						//let imageCaption = overlay.find('.img-caption');
						//imageCaption.text(productName.text());

						let overlayProductName = overlay.find('.product-name');
						overlayProductName.text(productName.text());
					});
				}
				this.showPreloader(false);
			});
		});

		try {
			this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
		} catch (error) {
			console.log(error);
		}
	}

	get isHomepage() {
		return true;
	}

	setHeaderLinks() {
		$('.js-logo-cdc')?.on('click', () => window.location.href = 'https://www.compagniadeicaraibi.com');
		$('.js-logo-dispensa')?.on('click', () => window.location.href = 'https://dispensa.com');
    }
}

